import React from 'react';
import styled from 'styled-components';

import SEO from '../../seo';

import PostBanner from './post-banner';
import PostContent from './post-content';

const SinglePostContainer = styled.div``;

const SinglePost = ({ post }) => {
    const { title, content, featuredImage } = post || {};
    return (
        <SinglePostContainer>
            <SEO title={post.title} />
            {featuredImage && (
                <PostBanner
                    image={featuredImage.node.localFile.childImageSharp.fluid}
                    post={post}
                />
            )}
            <PostContent content={content} />
        </SinglePostContainer>
    );
};

export default SinglePost;
